/*
 * Where the business-side links go. The marketplace has no sign-up or sign-in
 * of its own: registering is apps/web's /signup and the dashboard is app.,
 * because Supabase session cookies are host-only and a second copy of either
 * on this host would be signed in nowhere else.
 *
 * In development those are the Next app on :3000, not production.
 */

const ROOT_DOMAIN = import.meta.env.VITE_ROOT_DOMAIN || 'blooq.eastlaunch.com'
const DEV = import.meta.env.DEV

const WEB = import.meta.env.VITE_WEB_BASE || (DEV ? 'http://localhost:3000' : `https://${ROOT_DOMAIN}`)
const DASHBOARD = DEV ? 'http://localhost:3000/dashboard' : `https://app.${ROOT_DOMAIN}`

export const LINKS = {
  signup: `${WEB}/signup`,
  signIn: `${DASHBOARD}/login`,
  /** The product's own landing page: what a business gets, in full. */
  forBusinesses: WEB,
}
